import { Store } from 'cw-ui-core';
import {
    changeSelectAllResources,
    changeGrantAccessToAllFutureResources,
} from 'src/features/resources-assignment/slice';
import { RESOURCES_TYPES } from '../../constants';
import { isEmpty } from 'lodash';
import Locale from 'src/i18n';
import { formatMessage } from 'src/i18n/intl';

export const initialSortModel = [
    {
        field: 'companyName',
        sort: 'asc',
    },
];

const sortFieldsMapping = {
    name: 'name',
    friendlyName: 'friendlyName',
    companyName: 'company.name',
    locations: 'primaryAddress.country',
    type: 'type.name',
    containerName: 'company.corpContainer.name',
};

export const getTransformedSortModel = sortModel => {
    if (isEmpty(sortModel)) {
        return [];
    }
    const sortFieldsArray = sortModel.map(item => {
        const field = sortFieldsMapping[item.field] || item.field;
        return {
            field,
            sort: item.sort,
        };
    });
    return sortFieldsArray;
};

export const transformResponseToDataGridRows = response => {
    if (!response) return [];
    return response.map(row => {
        return {
            id: row.id,
            name: row.name || '',
            friendlyName: row.friendlyName || '',
            companyName: row.company.name || row.company.friendlyName,
            containerName: row.company.corpContainer?.name || '',
            locations:
                `${row.primaryAddress.country}${
                    row.primaryAddress.countryCode ? `, ${row.primaryAddress.countryCode}` : ''
                }` || '',
            type: row.type.name,
            company: row?.company || {},
        };
    });
};

export const getInheritedSitesFromCompanies = (sites, selectedCompaniesIds) =>
    sites.filter(site => selectedCompaniesIds.includes(site.company.id)).map(item => item.id);

export const removeItemsFromArray = (arr, removeItemsArr) => arr.filter(item => !removeItemsArr.includes(item));

export const populateSelectAllFutureSite = (
    totalSiteCount,
    selectAllCompany,
    grantAccessToAllFutureCompany,
    selectedSitesIds,
    grantAccessToAllFutureSite,
    selectAllResourcesSite
) => {
    if (
        (totalSiteCount > 0 && selectedSitesIds?.length > 0 && selectedSitesIds?.length >= totalSiteCount) ||
        (selectAllCompany && !selectAllResourcesSite)
    ) {
        Store().dispatch(
            changeSelectAllResources({
                resourceType: RESOURCES_TYPES.SITE,
                value: true,
            })
        );
    }
    if (grantAccessToAllFutureCompany && !grantAccessToAllFutureSite) {
        Store().dispatch(
            changeGrantAccessToAllFutureResources({
                resourceType: RESOURCES_TYPES.SITE,
                value: true,
            })
        );
    }
    if (selectAllCompany && !grantAccessToAllFutureCompany && grantAccessToAllFutureSite) {
        Store().dispatch(
            changeGrantAccessToAllFutureResources({
                resourceType: RESOURCES_TYPES.SITE,
                value: false,
            })
        );
    }
};

export const getFutureAllSiteCheckboxTooltipMessage = totalSelectedCompaniesIds => {
    return totalSelectedCompaniesIds.length > 0
        ? formatMessage(Locale.selectAllSitesCheckboxTooltipDisabled)
        : formatMessage(Locale.csGrantFutureSitesCheckboxTooltip);
};

export const getSelectAllSitesCheckboxTooltipMessage = totalSelectedCompaniesIds => {
    return totalSelectedCompaniesIds.length > 0
        ? formatMessage(Locale.selectAllSitesCheckboxTooltipDisabled)
        : formatMessage(Locale.selectAllSitesCheckboxTooltip);
};

export const checkSiteHasSetup = (rows, isLoading, filterModel) => {
    const noRecordsFound = rows?.length === 0 && !isLoading;
    const isFilterApplied = filterModel.items.length || filterModel.quickFilterValues.length;
    return noRecordsFound && !isFilterApplied;
};

export const getInheritedSiteMessage = (selectAllCompanyCheckbox, totalSelectedCompaniesIds) => {
    return selectAllCompanyCheckbox
        ? formatMessage(Locale.csInheritedSitesSelectAllAlertTitle)
        : formatMessage(Locale.csInheritedSitesAlertTitle, { selectedCompaniesLen: totalSelectedCompaniesIds.length });
};
